import { useEffect, Component } from "react";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bento from "@/components/Bento";
import DayByDay from "@/components/DayByDay";
import Species from "@/components/Species";
import Roi from "@/components/Roi";
import Specs from "@/components/Specs";
import Offer from "@/components/Offer";
import Support from "@/components/Support";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 48, fontFamily: "sans-serif", color: "#0F172A" }}>
          Algo salió mal al mostrar la página. Por favor recarga.
        </div>
      );
    }
    return this.props.children;
  }
}

function Landing() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="min-h-screen bg-brand-cloud text-brand-ink antialiased" data-testid="landing-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Bento />
        <DayByDay />
        <Species />
        <Roi />
        <Specs />
        <Offer />
        <Support />
        <Faq />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Landing />
    </ErrorBoundary>
  );
}
